import { atom } from "jotai";

export const isGameLiveAtom = atom(false);
export const rushTourModeAtom = atom<"rush" | "grand-rush" | "rookie-rush">("rush");
export const kothTourModeAtom = atom<"koth" | "rookie-koth">("koth");
export const championshipTourModeAtom = atom<"qualifier" | "bracket">("qualifier");
